module.exports = __webpack_public_path__ + "img/no-class.dc1a5435.svg";